export default "__VITE_ASSET__5MZBLdps__"